import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Shield, Users, Trophy, Zap, ChevronRight, Gamepad2 } from "lucide-react";
import { LOGO_WARZONE } from "@/lib/api";
import { IMG } from "@/lib/assets";
import api from "@/lib/api";

export default function SealsOfWarzone() {
  const [next, setNext] = useState(null);

  useEffect(() => {
    api.get("/public/tournaments").then(({ data }) => {
      setNext(data.active[0] || data.upcoming[0] || null);
    }).catch(() => {});
  }, []);

  return (
    <div className="text-white">
      {/* HERO */}
      <section className="relative min-h-[92vh] flex items-center overflow-hidden">
        <div className="absolute inset-0" style={{ backgroundImage: `url(${IMG.cyberBg})`, backgroundSize: "cover", backgroundPosition: "center" }} />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-[#050507]" />
        <div className="absolute inset-0 grid-overlay opacity-40" />
        <div className="relative max-w-7xl mx-auto px-5 grid md:grid-cols-2 gap-10 items-center py-16">
          <div className="fade-up">
            <h1 className="heading text-5xl sm:text-7xl lg:text-8xl leading-none"><span className="cyber-text">SEALS</span></h1>
            <p className="heading text-2xl tracking-[0.25em] text-gray-300 mt-4">FRIENDSHIP - TEAM WORK - DISCIPLINED</p>
            <p className="font-rajdhani text-gray-400 mt-5 max-w-lg text-lg">Il Reggimento dove nessuno viene lasciato solo ad affrontare i campi di battaglia di Call of Duty: Warzone.</p>
            <div className="flex flex-wrap gap-4 mt-8">
              <a href="#reggimento" className="btn-cyber clip-hud px-8 py-3">Scopri il Reggimento</a>
              <Link to="/tornei" className="btn-cyber-outline clip-hud px-8 py-3">Scopri i Tornei</Link>
            </div>
          </div>
          <div className="flex justify-center">
            <div className="relative floaty">
              <div className="absolute inset-0 scale-125 rounded-full" style={{ background: "radial-gradient(circle, rgba(5,5,7,0.92) 45%, transparent 72%)" }} />
              <img src={LOGO_WARZONE} alt="Seals" className="relative w-72 sm:w-96 object-contain drop-shadow-[0_0_60px_rgba(34,211,238,0.5)]" data-testid="warzone-hero-logo" />
            </div>
          </div>
        </div>
      </section>

      {/* CHI SIAMO */}
      <section id="reggimento" className="max-w-7xl mx-auto px-5 py-20">
        <div className="text-center mb-14">
          <h2 className="heading text-5xl">IL <span className="cyber-text">REGGIMENTO</span></h2>
          <p className="font-rajdhani uppercase tracking-[0.3em] text-[#67e8f9] text-sm mt-3">AMICIZIA - TEAM WORK - DISCIPLINA</p>
          <div className="w-24 h-0.5 bg-gradient-to-r from-[#22d3ee] to-[#a855f7] mx-auto mt-4" />
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {[
            { icon: Users, t: "Amicizia", d: "Una community dove nessuno gioca da solo: qui nascono amicizie vere, dentro e fuori dal campo di battaglia." },
            { icon: Shield, t: "Team Work", d: "Ogni operazione è costruita sul gioco di squadra: coordinazione, comunicazione e supporto reciproco." },
            { icon: Zap, t: "Disciplina", d: "Organizzazione e rispetto delle regole: un reggimento strutturato dove ogni membro conta davvero." },
          ].map((c, i) => (
            <div key={i} className="cyber-panel clip-hud p-7 fade-up" style={{ animationDelay: `${i * 0.1}s` }}>
              <c.icon className="w-9 h-9 text-[#67e8f9] mb-4" strokeWidth={1.5} />
              <h3 className="heading text-2xl text-white">{c.t}</h3>
              <p className="font-rajdhani text-gray-400 mt-2">{c.d}</p>
            </div>
          ))}
        </div>
      </section>

      {/* FILOSOFIA */}
      <section className="relative py-20 border-y border-white/10">
        <div className="absolute inset-0 grid-overlay opacity-30" />
        <div className="relative max-w-5xl mx-auto px-5 text-center">
          <h2 className="heading text-4xl sm:text-5xl">UNA <span className="cyber-text">MISSIONE</span>, UN OBIETTIVO</h2>
          <div className="font-rajdhani text-gray-300 text-lg mt-6 max-w-3xl mx-auto space-y-4 text-left">
            <p>I Seals nascono da un incontro randomico nelle lobby di Warzone di quattro ragazzi, in un periodo difficile per l’umanità durante la pandemia di COVID-19 nella primavera del 2020. Dal voler giocare semplicemente insieme, si è passati all’idea di creare un gruppo organizzato: i Seals. Dopo periodi di crescita e di fratture, che hanno a tratti decimato il gruppo, si è giunti a una forte stabilità soprattutto grazie alla forza di volontà di Gianca, Duigodom e Talivo. I Seals oggi rappresentano una community ampia ma molto unita. Talmente unita da considerarci una Famiglia!</p>
            <p>Guidata da solidi principi quali il rispetto reciproco, il gioco di squadra e la voglia di coinvolgere tutti i membri nelle iniziative organizzate dall’Amministrazione. Il reggimento cresce qualitativamente di giorno in giorno. I Seals sono sempre in via di sviluppo e di miglioramento: aumentiamo le nostre esperienze e capacità di gestione della community, ed aumentano i legami fra i membri della community stessa, rendendola sempre più forte e unita. L’espansione in termini numerici è conseguenza di una oculata selezione dei nuovi membri, che viene attuata dai nostri Reclutatori.</p>
            <p>Le nostre parole chiave: organizzazione ed amicizia.</p>
            <p>Per il futuro non ci poniamo limiti, ci godiamo il presente e l’esperienza di gioco insieme!</p>
            <p>Con questo, noi founder, testimoniamo un ringraziamento speciale a tutti i membri dello staff Seals: Admin - Staff Private - Reclutatori</p>
            <p className="cyber-text heading text-2xl">Gianca, Duigodom, Talivo</p>
          </div>
          <div className="grid grid-cols-3 gap-6 mt-12">
            {[["Community", Users], ["Eventi", Gamepad2], ["Tornei", Trophy]].map(([t, Ic], i) => (
              <div key={i} className="flex flex-col items-center gap-2">
                <Ic className="w-8 h-8 text-[#a855f7]" strokeWidth={1.5} />
                <span className="heading text-xl text-white tracking-wider">{t}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROSSIMO TORNEO */}
      <section className="max-w-7xl mx-auto px-5 py-20">
        <div className="cyber-panel clip-hud p-8 md:p-12 relative overflow-hidden" data-testid="warzone-next-tournament">
          <div className="absolute inset-0 grid-overlay opacity-20" />
          <div className="relative flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <span className="font-rajdhani uppercase tracking-[0.3em] text-[#67e8f9] text-xs">{next?.state === "in_progress" ? "Torneo in corso" : "Prossimo torneo"}</span>
              <h2 className="heading text-4xl sm:text-5xl mt-2">{next ? next.name : "Nuovi tornei in arrivo"}</h2>
              <p className="font-rajdhani text-gray-400 mt-1">{next ? `${next.mode} · ${next.map}` : "Resta connesso per gli aggiornamenti del reggimento."}</p>
            </div>
            <Link to="/tornei" className="btn-cyber clip-hud px-8 py-3 flex items-center gap-2 shrink-0">Scopri i Tornei <ChevronRight className="w-4 h-4" /></Link>
          </div>
        </div>
      </section>
    </div>
  );
}
